import {v4 as uuid } from 'uuid';
import isEmpty from 'lodash/isEmpty';

export function addRequired (field) {
    if (!this.required) {
        this.required = {};
    }
    this.required[field] = true;
}

export function validateRequired () {
    let requiredSatisfied = true;
    // console.log('validateRequired() Required: -> ', this.required);
    for (let field in this.required) {
        // console.log('validateRequired(): validating: ', field);
        if (this.required[field] && !this.requiredHasValue(field)) {
            requiredSatisfied = false;
            break;
        }
    }
    // console.log('validateRequired() fields are valid: ', requiredSatisfied);
    this.isRequiredFilledIn = requiredSatisfied;
    this.observed.isRequiredFilledIn = uuid();
}

export function requiredHasValue (field) {
    if (!isEmpty(this.subscribersFields[field])) {
        return true;
    }

    if (!isEmpty(this.customValues[field])) {
        return true;
    }
    const optinItem =  this.optinValues[field];
    if (!isEmpty(optinItem) && optinItem.value) {
        return true;
    }
    return false;
}